

const EcomSolution = () => {
  return (
    <div>
      <div className="">
        <img src="/ExpressBanner/banner-5.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
    
              <div className="flex flex-col justify-center">
                <h1 className="font-bold text-3xl text-[#373737]">
                  E-Com Solutions
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                  No other industry changes as rapidly and with as much effect as the E-commerce industry.
                  The market of E-commerce in Pakistan is at an extremely exciting stage given that it is still 
                  exploring and finding its own feet. The outlook for local entrepreneurs as well as venture capitalists 
                  remains strong in the medium to long term, which has helped many businesses, small and larger, to operate 
                  successfully and to build a customer base that would have been otherwise impossible to reach.
                </p>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                  With e-commerce industry booming and gaining momentum in Pakistan, TCS is leading the way, when 
                  it comes to bringing everything at the doorstep of our customers. When you remove the physical boundaries 
                  of a store, you offer a plethora of convenience to your customers; and this is where TCS can become your partner
                  in making customers’ lives convenient and easy.
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-center items-center">
                  <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
              </div>
        </div>
      
      </div>
    </div>
  );
};

export default EcomSolution;
